import { createContext, useContext } from 'react';

import { type FieldType } from '../constants';

import { useConfig } from './config-context';

export type FieldInitialData<T = any> = Partial<Record<FieldType, T>>;

export const FieldInitialDataContext = createContext<
  FieldInitialData | undefined
>(undefined);

export const useFieldInitialData = <T>(fieldType: FieldType): T => {
  const context = useContext(FieldInitialDataContext);
  const { isEditor, isComposer } = useConfig();

  if (isEditor || isComposer) {
    return {} as T;
  }

  if (context === undefined) {
    throw new Error(
      'useFieldInitialData must be used within a FieldInitialDataContext',
    );
  }

  return context[fieldType];
};
